import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AuthModule } from "../../../store/modules/auth.module";
import { getTenantId } from "@/store/helper";
import EcGrid from "@/components/widgets/EcGrid.vue";
let UserLogins = /** @class */ (() => {
    let UserLogins = class UserLogins extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "User Logins";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Analytics",
                    href: "#",
                },
                {
                    text: "User Logins",
                    active: true,
                },
            ];
            this.tenantId = "";
            this.pageIsLoading = true;
            this.selectedDate = null;
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.columns = [
                {
                    field: "dateTimeStampFormatted",
                    label: "TimeStamp",
                    sortable: false,
                },
                {
                    field: "userName",
                    label: "User",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        placeholder: "User",
                    },
                },
                {
                    field: "ipAddress",
                    label: "IP Address",
                    sortable: false,
                },
                {
                    field: "browser",
                    label: "User Agent",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.totalCount = this.totalUserCount;
            var convertedDate = this.dateFormatString(this.selectedDate);
            var date = convertedDate + " 00:00:00 AM";
            AuthModule.GetUserLoginAnalytics({ tenantId: this.tenantId, newDate: date, searchData: searchData }).then((response) => {
                this.isGridLoading = false;
                this.totalCount = this.totalUserCount;
            });
        }
        GetLoginAnalytics() {
            this.validate("datePickerObserver").then((response) => {
                if (response) {
                    this.loadItems();
                }
            });
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            this.serverParams.page = this.initialPage;
            this.serverParams.pageSize = this.initialPageSize;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.reset();
            if (this.selectedDate != null) {
                this.loadItems();
            }
        }
        get rows() {
            return AuthModule.loginAnalytics;
        }
        get loggedIn() {
            return AuthModule.loggedIn;
        }
        get notLoggedIn() {
            return AuthModule.notLoggedIn;
        }
        get totalUsers() {
            return AuthModule.totalUsers;
        }
        get totalLogins() {
            return AuthModule.totalLogins;
        }
        get totalUserCount() {
            return AuthModule.totalUserCount;
        }
        created() {
            this.tenantId = getTenantId();
        }
        destroyed() {
            AuthModule.ClearLoginAnalytics();
        }
    };
    UserLogins = __decorate([
        Component({
            name: "UserLogins",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
            },
        })
    ], UserLogins);
    return UserLogins;
})();
export default UserLogins;
